import { Component, Inject, OnInit } from '@angular/core';
import {
  StoreSubscription,
  SubscriptionsService,
} from './subscriptions.service';
import { map, mergeMap, share, take } from 'rxjs/operators';
import { CheckoutResponse } from '../../core/checkout';
import { from, Observable } from 'rxjs';
import { StripeError } from '@stripe/stripe-js';
import { loadStripe } from '@stripe/stripe-js/pure';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-subscriptions',
  templateUrl: './subscriptions.component.html',
  styleUrls: ['./subscriptions.component.scss'],
})
export class SubscriptionsComponent implements OnInit {
  subscription$: Observable<StoreSubscription> | undefined = undefined;

  constructor(
    private readonly subscriptionsService: SubscriptionsService,
    @Inject(DOCUMENT) private document: Document
  ) {}

  ngOnInit(): void {
    this.subscription$ = this.getUserSubscription();
  }

  subscribe(): void {
    this.subscriptionsService
      .checkout()
      .pipe(
        mergeMap((checkoutResponse) => this.redirectToStripe(checkoutResponse)),
        take(1)
      )
      .subscribe();
  }

  redirectToStripe(
    checkout: CheckoutResponse
  ): Observable<Promise<{ error: StripeError }> | undefined> {
    return from(loadStripe(checkout.publishable_key)).pipe(
      map((stripe) =>
        stripe?.redirectToCheckout({ sessionId: checkout.session_id })
      )
    );
  }

  redirectToManagementPortal(): void {
    this.subscriptionsService
      .getManagementPortalURL()
      .subscribe((link) => (this.document.location.href = link.session_url));
  }

  private getUserSubscription(): Observable<StoreSubscription> | undefined {
    return this.subscriptionsService.getUserSubscription().pipe(share());
  }
}
